import { render, staticRenderFns } from "./qAndADetial.vue?vue&type=template&id=0b613a4f&scoped=true"
import script from "./qAndADetial.vue?vue&type=script&lang=js"
export * from "./qAndADetial.vue?vue&type=script&lang=js"
import style0 from "./qAndADetial.vue?vue&type=style&index=0&id=0b613a4f&prod&lang=less"
import style1 from "./qAndADetial.vue?vue&type=style&index=1&id=0b613a4f&prod&lang=less&scoped=true"
import style2 from "./qAndADetial.vue?vue&type=style&index=2&id=0b613a4f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b613a4f",
  null
  
)

export default component.exports